import React, { useState, useEffect } from "react";

// let values = null;
// let errors = {};
let completed = true;

export default ({
  name,
  children,
  onChange,
  required = [],
  initialValues = {},
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  // initialValues is the source of truth whenever it changes from outside
  // (e.g. an AI agent replacing the whole filter set) — always fully resync
  // to it rather than keeping any of the previous `values`. The old version
  // of this effect left `values` untouched when initialValues went empty,
  // which meant a stale field (e.g. sector, nielsen_filters) would silently
  // reappear in the parent's state the next time any field was edited, since
  // updateValue below merges its own `values` back in via onChange.
  useEffect(() => {
    setValues({ ...(initialValues || {}) });
    setErrors({});
  }, [initialValues]);

  completed = true;

  required.map((req) => {
    if (
      !Object.keys(values).includes(req) ||
      !values[req] ||
      /^\s*$/.test(values[req])
    ) {
      completed = false;
    }
    return req;
  });

  const updateValue = ({ key, value, error = false, regex }) => {
    completed = true;
    if (value && value.length > 0 && regex && !RegExp(regex).test(value)) {
      error = true;
    }
    if (!error) {
      values[key] = value;
      delete errors[key];
    } else {
      errors[key] = value;
      delete values[key];
    }
    setValues(values);
    setErrors(errors);

    required.map((req) => {
      if (!Object.keys(values).includes(req)) {
        completed = false;
      }
      return req;
    });
    typeof onChange === "function" && onChange({ values, errors, completed });
  };
  return (
    <form name={name}>
      {typeof children === "function"
        ? children({ values, errors, completed, updateValue })
        : children}
    </form>
  );
};
